import { enCommon, enErrors, enRecorder, enRoutes, enTerms, enUi } from './en'
import { esCommon, esErrors, esRecorder, esRoutes, esTerms, esUi } from './es'

export const resources = {
  en: {
    common: enCommon,
    errors: enErrors,
    recorder: enRecorder,
    routes: enRoutes,
    terms: enTerms,
    ui: enUi,
  },
  es: {
    common: esCommon,
    errors: esErrors,
    recorder: esRecorder,
    routes: esRoutes,
    terms: esTerms,
    ui: esUi,
  },
}
